// Helper genérico de timeout (para update, etc.)
export async function withTimeout (promise, ms = 7000) {
  return new Promise((resolve, reject) => {
    let settled = false

    const timer = setTimeout(() => {
      if (settled) return
      settled = true
      // isTimeout: true — marca el rechazo SIN depender del string 'timeout' del mensaje (review
      // PR demo #201): otro withTimeout hermano (boot/offline.js) rechaza con un mensaje distinto
      // (`[offline-v2] boot step "..." timeout tras Xms`), asi que un caller que matcheara por
      // texto se rompia en silencio si algun dia se unifican. La marca es estable sin importar el
      // mensaje exacto.
      reject(Object.assign(new Error('timeout'), { isTimeout: true }))
    }, ms)

    promise
      .then(res => {
        if (settled) return
        settled = true
        clearTimeout(timer)
        resolve(res)
      })
      .catch(err => {
        if (settled) return
        settled = true
        clearTimeout(timer)
        reject(err)
      })
  })
}
